export const SET_CACHE = 'set cache';
export const UPDATE_CACHE = 'update cache';
export const REMOVE_FROM_CACHE = 'remove from cache';
export const CLEAR_CACHE = 'clear cache';
